import { lazyLoad } from '~/src/shared/utils/loadable';

export const MunicipalityCollaborationTohokuPage = lazyLoad(
  () => import('./index'),
  (module) => module.MunicipalityCollaborationTohoku,
);
